'use client'
import { FormilyProductDescription } from '@segway/core/src/graphql/generated/graphql'

import {
  AsExpertsSay,
  InterviewVideoPdp,
  SellPoint1Pdp,
  // SellPoint1Type,
  SellPoint2Pdp,
  // SellPoint2Type,
  SellPoint3Pdp,
  // SellPoint3Type,
  // SellPointsPdp,
} from '@/components/pdpDesc'
interface TProductDetailProps {
  data: Array<FormilyProductDescription>
}

const ProductDetails = ({ data }: TProductDetailProps) => {
  // const pageData = useMemo(() => {
  //   if (data && data.formilyPage) {
  //     const page_data = data.formilyPage.page_data
  //     return JSON.parse(page_data as string)
  //   }
  // }, [data])
  return (
    <div className="flex flex-col gap-24 max-xl:gap-[28px]">
      {data?.map((item) => {
        switch (item.type) {
          case 'pd_first_item':
            return <InterviewVideoPdp key={item.id} blockData={item.item_data!} />
          case 'pd_item_selling_point1':
            return <SellPoint1Pdp key={item.id} blockData={item.item_data!} />
          case 'pd_item_selling_point2':
            return <SellPoint2Pdp key={item.id} blockData={item.item_data!} />
          case 'pd_item_selling_point3':
            return <SellPoint3Pdp key={item.id} blockData={item.item_data!} />
          case 'pd_youtube_videos':
            return <AsExpertsSay key={item.id} blockData={item.item_data!} />
          default:
            return null
        }
      })}
    </div>
  )

  // return pageData ? (
  //   <div className="flex flex-col gap-24 max-xl:gap-11">
  //     <InterviewVideoPdp />
  //     <SellPointsPdp />
  //     {pageData.map(
  //       (item: {
  //         block_data: SellPoint1Type | SellPoint2Type | SellPoint3Type
  //         identify: string
  //         type: string
  //       }) => {
  //         switch (item.type) {
  //           case 'pd_selliing_point1':
  //             return (
  //               <SellPoint1Pdp key={item.identify} blockData={item.block_data as SellPoint1Type} />
  //             )
  //           case 'pd_selliing_point2':
  //             return (
  //               <SellPoint2Pdp key={item.identify} blockData={item.block_data as SellPoint2Type} />
  //             )
  //           case 'pd_selliing_point3':
  //             return (
  //               <SellPoint3Pdp key={item.identify} blockData={item.block_data as SellPoint3Type} />
  //             )
  //           default:
  //             return null
  //         }
  //       },
  //     )}
  //     <AsExpertsSay />
  //   </div>
  // ) : null
}

ProductDetails.displayName = 'ProductDetails'

export default ProductDetails
